import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Visor de PDF dentro de un modal: usa el visor integrado del navegador en un iframe
@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {

  @Input() title: string;
  @Input() url: string;

  safeUrl: SafeResourceUrl = null;
  isLoading: boolean = true;
  canShowInline: boolean = true;

  constructor(public activeModal: NgbActiveModal, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    // Algunos navegadores (por ejemplo Chrome en Android) no muestran PDFs dentro de la página
    const pdfViewerEnabled = (navigator as any).pdfViewerEnabled;
    this.canShowInline = pdfViewerEnabled !== false && this.canEmbed(this.url);
    if (this.canShowInline) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  }

  // Solo se embeben URLs http(s), y no se embebe http dentro de https porque el navegador lo bloquea
  private canEmbed(url: string): boolean {
    try {
      const protocol = new URL(url).protocol;
      if (protocol === 'https:') {
        return true;
      }
      return protocol === 'http:' && window.location.protocol !== 'https:';
    } catch {
      return false;
    }
  }
}
